var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15085 0.904869L4.59704 1.70439C4.9997 2.4259 4.83807 3.37242 4.20386 4.00662C4.20386 4.00662 3.43467 4.77594 4.82934 6.17067C6.22359 7.56492 6.99339 6.79616 6.99339 6.79616C7.6276 6.16194 8.57409 6.00031 9.29562 6.40298L10.0951 6.84917C11.1847 7.45719 11.3133 8.9851 10.3557 9.94279C9.78023 10.5182 9.07527 10.966 8.29599 10.9955C6.98417 11.0453 4.75633 10.7133 2.52154 8.47848C0.286778 6.24368 -0.0452292 4.01585 0.00450455 2.70401C0.0340464 1.92473 0.481801 1.21979 1.05725 0.644347C2.0149 -0.313308 3.5428 -0.184635 4.15085 0.904869Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.75f34e4f1cc2a8b7ce6c67cde9e72b32.svg";
export { ForwardRef as ReactComponent };